import styled from 'styled-components';

export const TableWrapper = styled.section`
  padding: 40px 64px;
`;
